import { Market, OptionMarket } from '#/api/markets';

export function isOptionMarket(market: Market): market is OptionMarket {
  return market.symbol.includes('-P-') || market.symbol.includes('-C-');
}
